import axios from '@axios'

export default {
  getActions(page, field) {
    return axios.post(`admin/actions/list?page=${page}`, field)
  },
}
